// src/components/Brand.jsx
import React from 'react';

const Brand = () => (
  <section id="trusted-by-the-best" className="bg-white text-center py-16">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <h2
        className="font_2 wixui-rich-text__text text-center mb-8 mt-11"
        style={{
          fontSize: '50px',
          fontFamily: 'Montserrat, sans-serif',
        }}
      >
        Trusted by the best.
        <br />
        <span style={{ fontSize: '20px', fontFamily: 'Montserrat, sans-serif' ,}}>
          Rubix has been the structural engineer-of-record on projects for leading brands.
        </span>
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 mt-12">
        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden flex justify-center items-center border border-gray-200 mx-auto">
          <img
            src="/assets/home/tjx logo.jpeg"
            alt="TJX Logo"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden flex justify-center items-center border border-gray-200 mx-auto">
          <img
            src="/assets/home/take%205%20logo.png"
            alt="Take 5 Logo"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden flex justify-center items-center border border-gray-200 mx-auto">
          <img
            src="/assets/home/mcd%20logo.png"
            alt="McDonald's Logo"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden flex justify-center items-center border border-gray-200 mx-auto">
          <img
            src="/assets/home/arbys.jpeg"
            alt="Arby's Logo"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden flex justify-center items-center border border-gray-200 mx-auto">
          <img
            src="/assets/home/chipotle%20logo.png"
            alt="Chipotle Logo"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden flex justify-center items-center border border-gray-200 mx-auto">
          <img
            src="/assets/home/starbucks%20logo.png"
            alt="Starbucks Logo"
            className="object-cover object-center w-full h-full"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Brand;
